import { useMemo } from 'react';

import { useLanguage } from './useLanguage';

const BASE_GUIDE_URL = 'https://guides.ontreams.com';
const AVAILABLE_GUIDE_LANGUAGES = ['en', 'nl'] as const;

type SlugsRecord = Partial<Record<(typeof AVAILABLE_GUIDE_LANGUAGES)[number], string>>;

export function useLocalizedGuideUrl<S extends SlugsRecord>(
	guideSlugs: S & (keyof S extends never ? { en: string } : object),
) {
	const { id: locale } = useLanguage();

	return useMemo(() => {
		const languageCode = locale.substring(0, 2);

		const guideLanguage =
			languageCode in guideSlugs
				? languageCode
				: AVAILABLE_GUIDE_LANGUAGES.find((language) => language in guideSlugs)!;

		return `${BASE_GUIDE_URL}/${guideLanguage}/article/${guideSlugs[guideLanguage]}`;
	}, [locale, guideSlugs]);
}
